import {
  Component,
  Signal,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { CourseVariablesService } from '../../../../academy/course/services/course-variables.service';
import { LanguageCode } from '../../models/CourseVariables';

@Component({
  selector: 'app-text-area',
  imports: [],
  templateUrl: './variable-text-area.component.html',
})
export class VariableTextAreaComponent {
  placeholder = input<string>('');
  name = input.required<string>();
  language = input.required<LanguageCode>();
  valueSignal = input.required<Signal<string>>();
  maxLength = input<number>(50);

  hasTranslation = input.required<boolean>();

  protected readonly value = signal('');
  protected readonly currentLength = signal(0);
  protected readonly isFocused = signal(false);
  private readonly courseVariablesService = inject(CourseVariablesService);

  constructor() {
    effect(() => {
      const v = this.valueSignal()();
      this.value.set(v);
      this.currentLength.set(v.length);
    });
  }

  onInput(event: Event) {
    const target = event.target as HTMLTextAreaElement;
    this.currentLength.set(target.value.length);
  }

  onBlur(event: Event) {
    this.isFocused.set(false);
    const target = event.target as HTMLTextAreaElement;
    if (target.value !== this.placeholder()) {
      this.courseVariablesService.updateVariable(
        this.name(),
        target.value,
        this.language(),
      );
    } else {
      this.value.set('');
      this.currentLength.set(0);
    }
  }

  onFocus() {
    this.isFocused.set(true);
    if (this.hasTranslation() && this.valueSignal()() === '') {
      this.value.set(this.placeholder());
      this.currentLength.set(this.value().length);
    }
  }
}
